module.exports = __webpack_public_path__ + "static/media/MASTER.d1ceeccf.svg";